import { render, staticRenderFns } from "./classifyList2.vue?vue&type=template&id=086a3866&scoped=true&"
import script from "./classifyList2.vue?vue&type=script&lang=js&"
export * from "./classifyList2.vue?vue&type=script&lang=js&"
import style0 from "./classifyList2.vue?vue&type=style&index=0&id=086a3866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a3866",
  null
  
)

export default component.exports